export const businessInfo = {
  name: '111 Sport Bar & Lounge',
  shortName: '111',
  tagline: 'Good food. Good drinks. Great times.',
  description: "Edmonton's neighbourhood destination for live sports, pub favourites, cold drinks, pool, and late-night energy.",
  address: '15215 111 Ave NW, Edmonton, AB T5M 2R1',
  phone: '+1 (825) 480-2418',
  phoneHref: 'tel:+18254802418',
  email: '111sportbar@gmail.com',
  hours: [
    { days: 'Monday - Saturday', hours: '11:00 AM - 2:00 AM' },
    { days: 'Sunday', hours: '3:00 PM - 12:00 AM' },
  ],
  kitchenHours: [
    { days: 'Monday - Saturday', hours: '11:00 AM - 11:00 PM' },
    { days: 'Sunday', hours: '3:00 PM - 11:00 PM' },
  ],
  featureNote: 'VLTs coming soon',
  mapUrl: 'https://www.google.com/maps/search/?api=1&query=15215+111+Ave+NW%2C+Edmonton%2C+AB+T5M+2R1',
  mapEmbedUrl: 'https://www.google.com/maps?q=15215%20111%20Ave%20NW%2C%20Edmonton%2C%20AB%20T5M%202R1&output=embed',
  socials: { instagram: '#', facebook: '#', tiktok: '#' },
}
